<template>
  <v-row dense>
    <v-col>
      <v-row dense v-if="!allowEdit">
        <v-col cols="6">
          <v-combobox
            v-model="preset"
            outlined
            dense
            label=""
            :items="guidancePresets"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'description', ''))"
            background-color="white"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Intervalo"
            :items="prescriptionFrequencies"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Quando"
            :items="prescriptionPeriods"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Periodo"
            :items="prescriptionHowLongs"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-textarea
            v-model="prescriptionGuidance.description"
            outlined
            dense
            label=""
            item-text="name"
            hide-details
            background-color="white"
            :disabled="allowEdit"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="auto" v-if="allowEdit">
          <v-btn @click="edit = true" color="light-blue" dark>Editar</v-btn>
        </v-col>

        <v-col cols="auto" v-if="allowEdit">
          <v-btn @click="deleteItem" color="error" dark>Remover</v-btn>
        </v-col>

        <v-col cols="auto" v-else>
          <v-btn @click="saveItem" color="light-blue" dark>Salvar</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "PrescriptionFormGuidance",
    props: {
      prescriptionGuidance: {
        type: Object,
        default: () => {
          return {
            key: "",
            description: "",
          };
        },
      },
      guidancePresets: Array,
      prescriptionFrequencies: Array,
      prescriptionPeriods: Array,
      prescriptionHowLongs: Array,
      addItem: Function,
      removeItem: Function,
      visualization: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        preset: "",
        edit: false,
      };
    },
    computed: {
      allowEdit() {
        if (this.visualization) {
          if (this.edit) {
            return !this.edit;
          }

          return this.visualization;
        }

        return this.visualization;
      },
    },
    methods: {
      concatPreset(text) {
        this.prescriptionGuidance.description += ` ${text}`;
        this.prescriptionGuidance.description = this.prescriptionGuidance.description.trim();
        this.preset = "";
      },
      saveItem() {
        this.addItem(this.prescriptionGuidance);
        this.edit = false;
      },
      deleteItem() {
        if (confirm("Você realmente deseja deletar essa orientação?")) {
          this.removeItem(this.prescriptionGuidance);
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
